import { FC } from "react";
import styles from "./Loading.module.css";

export const Loading: FC = () => {
  return (
    <div className={styles.ldsSpinner}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
